export default __webpack_public_path__ + "static/media/microsoft-login.c0bab622.svg";